"use strict";

var $ = jQuery.noConflict();
var $banner = $('#banner');
var $related = $('.related-slider');
var isHome = $('body').hasClass('home');

function bannerInit() {
  if ($banner.length) {
    $banner.slick({
      autoplay: true,
      prevArrow: '<div class="slick-prev">' + localize.prevArrow + '</div>',
      nextArrow: '<div class="slick-next">' + localize.nextArrow + '</div>'
    });

    if (isHome && $(window).width() > 767) {
      $banner.height($(window).height());
    }
  }
}

function relatedInit() {
  if ($related.length) {
    $related.slick({
      infinite: false,
      prevArrow: '<div class="slick-prev"></div>',
      nextArrow: '<div class="slick-next"></div>',
      mobileFirst: true,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      }]
    });
  }
}

$(document).ready(function () {
  bannerInit();
  relatedInit();
  $(window).resize(function () {
    if (isHome) {
      if ($(window).width() < 768) {
        $banner.css('height', '');
      } else {
        $banner.height($(window).height());
      }
    }
  });
});